export default "__VITE_ASSET__D1wkHt3a__"